import { HTTP } from "../http";
import moment from "moment";
import { requestHandler } from "../mixins/requestHandler";

export default {
  getCurrentDate({ commit }) {
    const date = moment().format("YYYY-MM-DD");
    commit("setFromDate", date);
    commit("setToDate", date);
    commit("setCurrentDate", date);
  },

  setToDate({ commit, getters }, d) {
    commit("setToDate", d);
    let to = Date.parse(d);
    let from = Date.parse(getters["getFromDate"]);
    if (from > to) {
      commit("setFromDate", d);
    }
  },

  setFromDate({ commit, getters }, d) {
    commit("setFromDate", d);
    let from = Date.parse(d);
    let to = Date.parse(getters["getToDate"]);
    if (from > to) {
      commit("setToDate", d);
    }
  },

  getUserDetails: async ({ commit }) => {
    try {
      const { data } = await HTTP.get("user/get-params");
      commit("setParams", data);
      return data;
    } catch (e) {
      if (e.response.status === 401) {
        localStorage.removeItem("so_token");
        if (location.hostname !== "localhost") {
          location.assign(`${location.origin}/login`);
        }
      } else {
        console.log(e.message);
        return false;
      }
    }
  },
  getRedirectDetails: async ({ dispatch }) => {
    try {
      const { data } = await HTTP.get("agency/get-params/lk_enter");
      return data;
    } catch (e) {
      if (e.response.status === 401 && localStorage.getItem("so_token")) {
        dispatch("getRedirectDetails");
      }
    }
  },
  async getMenu({ commit }, payload) {
    try {
      const { data } = await HTTP.post("menu/get-menu", payload);
      const isSingle = Object.prototype.hasOwnProperty.call(data, "single");
      commit("setMainMenu", isSingle ? data.single : data.common);
      commit("setSettingsMenu", data.settings);
    } catch (e) {
      console.log(e.message);
    }
  },

  setPultInDataBase(state, payload) {
    return new Promise((resolve, reject) => {
      HTTP.post("pult/update", payload).then(
        (res) => {
          resolve(res.status);
        },
        (res) => {
          reject(res);
        },
      );
    });
  },
  async getParsersList({ commit }) {
    try {
      const { data } = await HTTP.get("tt/screen/form");
      commit("setParsersList", data);
    } catch (e) {
      console.log(e.message);
    }
  },

  getRouteReceiptPDF(context, payload) {
    return new Promise(function(resolve, reject) {
      HTTP.post("tt/orders/services/route-receipt/pdf", payload).then(
        (res) => {
          if (res.data.status) {
            let linkExcel = document.createElement("a");
            linkExcel.href = `data:application/pdf;base64,${res.data.data}`;
            const ag = payload.prBK ? "_ag" : "";
            linkExcel.download =
              res.data.name || `MK_${payload.serviceId}${ag}.pdf`;
            linkExcel.click();
            res.data.data = "";
            resolve(res.data);
          } else {
            reject(res.data.error);
          }
        },
        (text) => {
          reject(text);
        },
      );
    });
  },
  getRouteReceiptPDFByPnr(context, payload) {
    return new Promise(function(resolve, reject) {
      HTTP.post("tt/orders/services/route-receipt/pdf/pnr", payload).then(
        (res) => {
          if (res.data.status) {
            let linkExcel = document.createElement("a");
            linkExcel.href = `data:application/pdf;base64,${res.data.data}`;
            const ag = payload.bk ? "_ag" : "";
            linkExcel.download = res.data.name || `MK_${payload.pnr}${ag}.pdf`;
            linkExcel.click();
            res.data.data = "";
            resolve(res.data);
          } else {
            reject(res.data.error);
          }
        },
        (text) => {
          reject(text);
        },
      );
    });
  },
  createServiceReceipt: async (_, payload) => {
    try {
      const { data } = await HTTP.get(
        `tt/orders/services/receipt/service/${payload.num}/order/${payload.id}`,
      );
      return data;
    } catch (e) {
      console.log(e.message);
    }
  },
  /**
   * Сформировать новый чек по заказу
   * @param {*} context
   * @param {*} payload
   */
  createCheck: async ({ commit }, payload) => {
    try {
      let { data } = await HTTP.post(
        `tt/orders/orders/check/${payload.orderId}`,
        payload.data,
      );
      if (data.status && data.data.receipt_id !== "0") {
        commit(
          "addOrderReceipt",
          {
            id: payload.orderId,
            data: {
              receiptId: data.data.receipt_id,
              check: data.data.check_status,
            },
          },
          { root: true },
        );
      } else data = { ...data, status: false };
      return data;
    } catch (e) {
      console.log(e.message);
    }
  },
  /**
   * Разбор экрана
   * @param {*} context
   * @param {Object} payload
   */
  parseScreen: async (_, payload) => {
    try {
      const { data } = await HTTP.post("tt/screen/parse", payload);
      return data;
    } catch (e) {
      console.log(e.message);
    }
  },
  /**
   * Получение списка кассиров
   * @param {*} context
   */
  async getCashierList({ commit }) {
    try {
      const { data } = await HTTP.get(`tt/orders/common/cashier/list`);
      commit("setCashierList", data.data);
    } catch (e) {
      console.log(e.message);
    }
  },
  /**
   * Выполняет запрос на удаление услуги
   * @param {*} context
   * @param {*} payload
   */
  deleteService: async ({ commit }, payload) => {
    try {
      const { data } = await HTTP.delete(
        `tt/orders/services/delete/${payload}`,
      );
      if (data.status) {
        commit("deleteService", payload);
      }
      return data;
    } catch (e) {
      console.log(e.message);
    }
  },

  /**
   * Выполняет запрос на назначение кассира на документы из АСБ
   * @param {*} context
   * @param {*} payload
   */
  assignCashier: async (_, payload) => {
    try {
      const { data } = await HTTP.post(
        "tt/orders/gdsdocuments/assign-cashier",
        payload,
      );
      return data;
    } catch (e) {
      console.log(e.message);
    }
  },
  async getServicesList({ commit }, payload) {
    try {
      commit("setServicesList", []);
      const response = await requestHandler(
        "tt/orders/services",
        payload,
        true,
      );
      commit("setServicesList", response.data);
    } catch (e) {
      console.log(e.message);
    }
  },
  getFopList: async ({ commit }) => {
    try {
      const { data } = await HTTP.get(`tt/orders/common/fo/list`);
      commit("setFopList", data.data);
      return {
        status: data.status,
        error: data.error,
      };
    } catch (e) {
      console.log(e.message);
    }
  },
  getBalance: async () => {
    try {
      const { data } = await HTTP.get("get/balance");
      return data;
    } catch (e) {
      console.log(e.message);
    }
  },
  /**
   * Получение списка документов из АСБ
   * @param {*} context
   * @param {*} payload
   */
  getDocumentsList: async ({ commit }, payload) => {
    try {
      const { data } = await HTTP.get(`tt/orders/gdsdocuments/${payload}`);
      commit("setDocumentsList", data.Docs.data);
      commit("setDocumentsDeep", data.Deep);
    } catch (e) {
      console.log(e.message);
    }
  },
  async loadOnlineFilesData({ commit }) {
    try {
      const { data } = await HTTP.get(`order/tab/service/get/onlinefiles`);
      if (data) {
        commit("setDocumentsList", data.data.files);
        commit("setPayCodes", data.data.lists.fop);
        commit("setPayTypes", data.data.lists.st);
      }
    } catch (e) {
      if (e.response.status === 500) {
        commit("setLoading", false);
      }
      console.log(e.message);
    }
  },
  getTokenForOldBack: async ({ commit }) => {
    try {
      const data = await HTTP.get(`old/get/token`);
      commit("setToken", data.data);
      return data.data;
    } catch (e) {
      console.log(e.message);
    }
  },

  async getDailyReports({ commit }, payload) {
    try {
      const { data } = await HTTP.post("cs/get/daily-reports", payload);
      commit("setDailyReportsList", data.data);
    } catch (e) {
      console.log(e.message);
    }
  },

  recalcSaldo: async (_, payload) => {
    try {
      const { data } = await HTTP.post("cs/get/recalc-saldo", payload);
      return data;
    } catch (e) {
      console.log(e.message);
    }
  },

  createReport: async (_, payload) => {
    try {
      const { data } = await HTTP.post(
        "cashier/template/newcashreport",
        payload,
      );
      return data;
    } catch (e) {
      console.log(e.message);
    }
  },

  /**
   * Получение отчета для сохранения в файл
   * @param {*} payload
   */
  getReportByCode: async (_, payload) => {
    try {
      const { data } = await HTTP.post("reports/get/report", payload.data);
      if (data.status) {
        let linkExcel = document.createElement("a");
        linkExcel.href = `data:application/octet-stream;base64,${data.data[0]}`;
        linkExcel.download = payload.fileName
          ? `${payload.fileName}.xls`
          : data.data[1];
        linkExcel.click();
      } else {
        if (Array.isArray(data.errors)) {
          return data.errors.join(". ");
        }
        if (typeof data.errors === "string") {
          return data.errors;
        }
      }
      return data;
    } catch (e) {
      console.log(e.message);
    }
  },
  getColumns: async ({ commit }, payload) => {
    try {
      const { data } = await HTTP.get("columns/get/" + payload);
      commit("setColumnsOnGrid", {
        gridId: payload,
        data: data,
      });
      return data;
    } catch (e) {
      console.log(e.message);
    }
  },
  async setColumns(_, payload) {
    try {
      const { data } = await HTTP.post("columns/set", payload);
      return data[0];
    } catch (e) {
      console.log(e.message);
    }
  },
  getCommissionSubjects: async () => {
    try {
      const { data } = await HTTP.get("cs/get/lists/subjects");
      return data;
    } catch (e) {
      console.log(e.message);
    }
  },
  sendMonitoringEvent: async (_, payload) => {
    try {
      const { data } = await HTTP.post("monitoring/store-event", payload);
      return data;
    } catch (e) {
      console.log(e.message);
    }
  },
  checkNewModuleUsing: async () => {
    try {
      const { data } = await HTTP.get("newmodule");
      return data;
    } catch (e) {
      return false;
    }
  },
  getReportType: async (_, payload) => {
    try {
      const { data } = await HTTP.post("reports/report-type/get", payload);
      return data.data;
    } catch (e) {
      console.log(e.message);
    }
  },
  /**
   * Получение списка отчетов для кассиров или бухгалтеров в БК и ОК
   * @param {*} context
   * @param {*} payload
   */
  async getReportsAdditionalList({ commit }, payload) {
    try {
      commit("setReportsAdditionalList", []);
      const response = await requestHandler(`reports/shortlist`, payload, true);
      commit("setReportsAdditionalList", response.data);
      return response.data;
    } catch (e) {
      console.log(e.message);
    }
  },
  async getAdditionalTemplates({ commit }, payload) {
    try {
      const { data } = await HTTP.get(`reports/templates/${payload}`);
      commit("setAdditionalTableTemplates", data.data);
    } catch (e) {
      console.log(e.message);
    }
  },
  async getAdditionalTemplateData({ commit }, payload) {
    try {
      if (Array.isArray(payload.params)) {
        await Promise.all(
          payload.params.map((p) => {
            return HTTP.post("reports/report/data", {
              procedure: payload.procedure,
              params: p,
            }).then((response) => response.data);
          }),
        )
          .then((res) => {
            const result = res.reduce((acc, val) => acc.concat(val.data), []);
            commit("setAdditionalReportData", result);
          })
          .catch((err) => console.log(err.message));
      } else {
        const { data } = await HTTP.post("reports/report/data", payload);
        commit("setAdditionalReportData", data.data);
      }
    } catch (e) {
      throw new Error(e.message);
    }
  },
  async deleteAdditionalTableTemplate({ commit }, payload) {
    try {
      const { data } = await HTTP.delete("reports/templates/delete/" + payload);
      if (data.status) {
        commit("removeTableTemplate", payload);
      }
      return data;
    } catch (e) {
      console.log(e.message);
    }
  },
  saveAdditionalTableTemplate: async (_, payload) => {
    try {
      const { data } = await HTTP.post("reports/templates/save", payload);
      return data;
    } catch (e) {
      console.log(e.message);
    }
  },
  deleteServiceFromAdditionalReportData: async ({ commit }, payload) => {
    try {
      const { data } = await HTTP.delete(
        `reports/report/blank/${payload.idBso}`,
      );
      if (data.status) {
        if (payload.location === "additionalReports") {
          commit("deleteServiceFromAdditionalReportData", payload.idBso);
        } else {
          commit("deleteServiceFromAgencyReports", payload.idBso);
        }
      }

      return data;
    } catch (e) {
      console.log(e.message);
    }
  },
};
